import React from 'react';

/**
 * Brand tagline used on public (non-authenticated) pages.
 * Keep it lightweight and reusable.
 */
export default function Tagline({ className = '' }) {
  return (
    <span
      className={[
        'text-sm md:text-base text-slate-600',
        'font-medium',
        className,
      ].join(' ')}
    >
      Votre cockpit de trésorerie <span className="text-slate-500">(micro &amp; indépendants)</span>
    </span>
  );
}
